// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../../styles/colors.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Common Styles */

.HcxOzDhtGhOdq9nCCWJg {
  border-radius: 4px;
  font-weight: bold;
  line-height: 16px;
  /* Limit transitions to visual props only to avoid layout jank */
  transition: background-color .1s ease-in-out, box-shadow .1s ease-in-out, color .1s ease-in-out, border-color .1s ease-in-out;
  text-align: center;
}

a.HcxOzDhtGhOdq9nCCWJg {
  display: inline-block;
  text-decoration: none !important;
}

/* Remove default focus outline; rely on component/theme focus styles */
.HcxOzDhtGhOdq9nCCWJg:focus {
  outline: none;
}

.HcxOzDhtGhOdq9nCCWJg:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Sizes */

.Ec5utF_Q9pjnaRT_1440 {
  font-size: 12px;
  padding: 8px 15px 6px;
  box-sizing: border-box;
}

.xH_j4iagXxBn3lG3N0yb {
  margin-right: 16px !important;
}

.MmFqaHuq3FS_o7ZehQei {
  margin-left: 16px !important;
}

.YFxDqReemitmoHM_RYF6 {
  font-size: 14px;
  padding: 16px 26px 14px;
  box-sizing: border-box;
}

.JDyDqzDFVrTq835E4QMz {
  margin-right: 24px !important;
}

.C3VzexntvtV9VTN5QCWZ {
  margin-left: 24px !important;
}

.ga1AblrR3wM92etv8jyU {
  width: 100%;
}

/* Color */

/* important to ensure link buttons stay the same on hover */
.GfSp8iFQhlibGHfh6pxg {
  color: white !important;
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-primary"]};
  /* border: 1px solid #29A2B3; */
  border-radius: 4px;
  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.2);
}

.GfSp8iFQhlibGHfh6pxg:hover {
  background: #25a8b9;
  /* border: 1px solid #29A2B3; */
  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.4);
}

.GfSp8iFQhlibGHfh6pxg:active {
  background: #0092A1;
  /* border: 1px solid #29A2B3; */
  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.4);
}
/* Remove extra focus ring; use theme-level focus styles */
.GfSp8iFQhlibGHfh6pxg:focus {
  box-shadow: none;
  outline: none;
}

.FHOqkLCUM7HyEwmCeuQA {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-secondary"]};
  /* background: white; */
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
  /* border: 1px solid hc-outline; */
  border-radius: 4px;
}

.FHOqkLCUM7HyEwmCeuQA:hover {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  /* background: #fdfdfd; */
  /* color: hc-navy; */
}

.FHOqkLCUM7HyEwmCeuQA:active {
  /* background: #f7f7f7; */
  /* color: hc-navy; */
}

.ORWdne5duF2MddSNFGQq {
  background: white;
  /* important to ensure link buttons stay the same on hover */
  color: #2FB5C7 !important;
  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.2);
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-primary"]};
  border-radius: 4px;
}

.ORWdne5duF2MddSNFGQq:hover {
  background: #f8fafc;
}

.ORWdne5duF2MddSNFGQq:active {
  background: #f1f5f9;
}


.b0416hA8FylV1J9JfYs8 {
  /* important to ensure link buttons stay the same on hover */
  color: white !important;
  background-color: #A3030A;
  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.2);
  border: none;
}

.b0416hA8FylV1J9JfYs8:hover {
  background-color: #A30D0F;
  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.4);
}

.b0416hA8FylV1J9JfYs8:active {
  background-color: #A30D0F;
  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.4);
}
.b0416hA8FylV1J9JfYs8:focus {
  box-shadow: none;
  outline: none;
}

/* dropdown button */

.q_ju4RCAmmS6_lwkFxkg {
  position: relative;
  display: inline-block;
}

.Q_kNnWxLTxwJdLAMivOU {
  position: absolute;
  right: 0;
  background: white;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]};
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.rqjo3j015q6cgbj3mL91 {
  color: #6d6d6d;
  cursor: pointer;
  padding: 7px 16px 6px;
  user-select: none;
}

.rqjo3j015q6cgbj3mL91:hover {
  background-color: whitesmoke;
}

.rqjo3j015q6cgbj3mL91:active {
  background: #ececec;
}

.q_ju4RCAmmS6_lwkFxkg button:not(.oCk9J0vZpa28e8kMuMp2) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.q_ju4RCAmmS6_lwkFxkg .oCk9J0vZpa28e8kMuMp2 {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.YFxDqReemitmoHM_RYF6.oCk9J0vZpa28e8kMuMp2 {
  padding-left: 12px;
  padding-right: 12px;
}

.X_CfsgQIGKup12gJTpZ6 {
  position: absolute;
  top: 12px;
  right: 15px;
  cursor: pointer;
  font-size: 18px;
  color: #6e6e6e;
}
@media (max-width: 695px) {
  .X_CfsgQIGKup12gJTpZ6 {
    top: 16px;
    right: 16px;
  }
}

.X_CfsgQIGKup12gJTpZ6:active {
  background-color: #e6e6e6;
}`, "",{"version":3,"sources":["webpack://./src/components/haven-design/buttons/buttons.module.css"],"names":[],"mappings":"AAEA,kBAAkB;;AAElB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gEAAgE;EAChE,6HAA6H;EAC7H,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,uEAAuE;AACvE;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,UAAU;;AAEV;EACE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA,UAAU;;AAEV,4DAA4D;AAC5D;EACE,uBAAuB;EACvB,8DAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,8CAA8C;AAChD;AACA,0DAA0D;AAC1D;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mDAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,4DAA4D;EAC5D,yBAAyB;EACzB,8CAA8C;EAC9C,8DAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,4DAA4D;EAC5D,uBAAuB;EACvB,yBAAyB;EACzB,8CAA8C;EAC9C,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA,oBAAoB;;AAEpB;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,8DAA4B;EAC5B,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE;IACE,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@value colors: \"../../../styles/colors.module.css\";\n@value hc-primary, hc-navy, hc-outline, hc-error, hc-secondary from colors;\n/* Common Styles */\n\n.base {\n  border-radius: 4px;\n  font-weight: bold;\n  line-height: 16px;\n  /* Limit transitions to visual props only to avoid layout jank */\n  transition: background-color .1s ease-in-out, box-shadow .1s ease-in-out, color .1s ease-in-out, border-color .1s ease-in-out;\n  text-align: center;\n}\n\na.base {\n  display: inline-block;\n  text-decoration: none !important;\n}\n\n/* Remove default focus outline; rely on component/theme focus styles */\n.base:focus {\n  outline: none;\n}\n\n.base:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Sizes */\n\n.small {\n  font-size: 12px;\n  padding: 8px 15px 6px;\n  box-sizing: border-box;\n}\n\n.smallMarginRight {\n  margin-right: 16px !important;\n}\n\n.smallMarginLeft {\n  margin-left: 16px !important;\n}\n\n.large {\n  font-size: 14px;\n  padding: 16px 26px 14px;\n  box-sizing: border-box;\n}\n\n.largeMarginRight {\n  margin-right: 24px !important;\n}\n\n.largeMarginLeft {\n  margin-left: 24px !important;\n}\n\n.fullWidth {\n  width: 100%;\n}\n\n/* Color */\n\n/* important to ensure link buttons stay the same on hover */\n.primary {\n  color: white !important;\n  background-color: hc-primary;\n  /* border: 1px solid #29A2B3; */\n  border-radius: 4px;\n  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.2);\n}\n\n.primary:hover {\n  background: #25a8b9;\n  /* border: 1px solid #29A2B3; */\n  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.4);\n}\n\n.primary:active {\n  background: #0092A1;\n  /* border: 1px solid #29A2B3; */\n  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.4);\n}\n/* Remove extra focus ring; use theme-level focus styles */\n.primary:focus {\n  box-shadow: none;\n  outline: none;\n}\n\n.secondary {\n  color: hc-secondary;\n  /* background: white; */\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);\n  /* border: 1px solid hc-outline; */\n  border-radius: 4px;\n}\n\n.secondary:hover {\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);\n  /* background: #fdfdfd; */\n  /* color: hc-navy; */\n}\n\n.secondary:active {\n  /* background: #f7f7f7; */\n  /* color: hc-navy; */\n}\n\n.tertiary {\n  background: white;\n  /* important to ensure link buttons stay the same on hover */\n  color: #2FB5C7 !important;\n  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.2);\n  border: 1px solid hc-primary;\n  border-radius: 4px;\n}\n\n.tertiary:hover {\n  background: #f8fafc;\n}\n\n.tertiary:active {\n  background: #f1f5f9;\n}\n\n\n.dangerous {\n  /* important to ensure link buttons stay the same on hover */\n  color: white !important;\n  background-color: #A3030A;\n  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.2);\n  border: none;\n}\n\n.dangerous:hover {\n  background-color: #A30D0F;\n  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.4);\n}\n\n.dangerous:active {\n  background-color: #A30D0F;\n  box-shadow: 0px 2px 4px rgba(46, 50, 128, 0.4);\n}\n.dangerous:focus {\n  box-shadow: none;\n  outline: none;\n}\n\n/* dropdown button */\n\n.dropdownContainer {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdownMenu {\n  position: absolute;\n  right: 0;\n  background: white;\n  border: 1px solid hc-outline;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);\n  border-radius: 4px;\n}\n\n.dropdownItem {\n  color: #6d6d6d;\n  cursor: pointer;\n  padding: 7px 16px 6px;\n  user-select: none;\n}\n\n.dropdownItem:hover {\n  background-color: whitesmoke;\n}\n\n.dropdownItem:active {\n  background: #ececec;\n}\n\n.dropdownContainer button:not(.dropdownCaret) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.dropdownContainer .dropdownCaret {\n  border-left: none;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.large.dropdownCaret {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n.closeButton {\n  position: absolute;\n  top: 12px;\n  right: 15px;\n  cursor: pointer;\n  font-size: 18px;\n  color: #6e6e6e;\n}\n@media (max-width: 695px) {\n  .closeButton {\n    top: 16px;\n    right: 16px;\n  }\n}\n\n.closeButton:active {\n  background-color: #e6e6e6;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../styles/colors.module.css"`,
	"hc-primary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-primary"]}`,
	"hcPrimary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-primary"]}`,
	"hc-navy": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-navy"]}`,
	"hcNavy": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-navy"]}`,
	"hc-outline": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]}`,
	"hcOutline": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-outline"]}`,
	"hc-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]}`,
	"hcError": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-error"]}`,
	"hc-secondary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-secondary"]}`,
	"hcSecondary": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["hc-secondary"]}`,
	"base": `HcxOzDhtGhOdq9nCCWJg`,
	"small": `Ec5utF_Q9pjnaRT_1440`,
	"smallMarginRight": `xH_j4iagXxBn3lG3N0yb`,
	"smallMarginLeft": `MmFqaHuq3FS_o7ZehQei`,
	"large": `YFxDqReemitmoHM_RYF6`,
	"largeMarginRight": `JDyDqzDFVrTq835E4QMz`,
	"largeMarginLeft": `C3VzexntvtV9VTN5QCWZ`,
	"fullWidth": `ga1AblrR3wM92etv8jyU`,
	"primary": `GfSp8iFQhlibGHfh6pxg`,
	"secondary": `FHOqkLCUM7HyEwmCeuQA`,
	"tertiary": `ORWdne5duF2MddSNFGQq`,
	"dangerous": `b0416hA8FylV1J9JfYs8`,
	"dropdownContainer": `q_ju4RCAmmS6_lwkFxkg`,
	"dropdownMenu": `Q_kNnWxLTxwJdLAMivOU`,
	"dropdownItem": `rqjo3j015q6cgbj3mL91`,
	"dropdownCaret": `oCk9J0vZpa28e8kMuMp2`,
	"closeButton": `X_CfsgQIGKup12gJTpZ6`
};
export default ___CSS_LOADER_EXPORT___;
